var map = {
	"./images/broken_glass.png": 5,
	"./images/share.png": 6
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16;


//////////////////
// WEBPACK FOOTER
// ./src/media ^\.\/.*\.*
// module id = 16
// module chunks = 0